import React, { useEffect, useState } from 'react';
import { injectIntl, IntlShape } from 'react-intl';
import { cloneDeep, get, isEmpty } from 'lodash';
import { useSelector } from 'react-redux';
import moment from 'moment';
import { JudgementADDDocumentType } from 'containers/common/LegalProceedings/JudgementAdd/Forms/JudgementAddPrononcings/typings';
import { Container } from 'containers/LawyerLegalProceedingsPage/judgementAdd/styled-components';
import { Vehicule } from 'containers/PreOpeningPage/typings';
import { Listings } from 'containers/AppContainer/typings';
import {
  IJudgementAdd,
  IUploadedDocument,
} from 'containers/LawyerLegalProceedingsPage/typings';
import { FEATURES } from 'features/features';
import * as featureService from 'features/fflip-helpers';
import { Idetails } from 'containers/common/LegalProceedings/JudgementAdd/Forms/ProcedureInformation/typings';
import { DETAIL_JUGEMENT_ADD, EMPTY_DETAIL } from 'containers/data-structure';
import FormsADD from 'containers/LawyerLegalProceedingsPage/AppealAdd/ProcedureInformation/FormADD';
import { detailsValidator } from 'containers/common/LegalProceedings/JudgementAdd/Forms/ProcedureInformation/form-validation';
import { validateFormFields } from 'containers/services/validateForm';
import {
  AppealAddDocType,
  APPEAL_DOC_ID,
  EMPTY_APPEAL_ADD_DOC,
} from 'containers/LawyerLegalProceedingsPage/AppealAdd/constants';
import { CorporealDocument } from 'containers/common/LegalProceedings/JudgementAdd/Forms/JudgementAddPrononcings/typings';
import RecapADD from 'containers/common/LegalProceedings/AppealAdd/index';
import { arrayTranslate } from 'containers/services/translate';
import { displayErrorText } from 'containers/services/validateForm';
import {
  EMPTY_SUPPORT_DOC,
  SUPPORT_DOC_JUDGEMENT_ADD_ID,
} from 'containers/LawyerRecapPage/constants';
import {
  getVehicles,
  getVictims,
  toBeEdited,
} from 'containers/LawyerLegalProceedingsPage/judgementAdd/utils';
import EditJudgementAddOnRejection from 'containers/LawyerLegalProceedingsPage/judgementAdd/EditJudgementAddOnRejection';
import {
  IndexState,
  IOpenState,
} from 'containers/LawyerLegalProceedingsPage/judgementAppeal/typings';
import {
  DRAWERS,
  DRAWERS_STATE,
} from 'containers/CourtManagerLegalProceedings/JudgementAdd/constants';
import currentIntervenantStorage from 'containers/services/security/current-intervenant-storage';
import { CURRENT_INDEX_STATE } from 'containers/LawyerLegalProceedingsPage/judgementAppeal/constants';
import { filterVictim } from 'containers/CourtManagerLegalProceedings/utils';
import { addDaysToDate } from 'containers/common/LegalProceedings/JudgementAdd/Forms/ProcedureInformation/utils';
import userPrivileges, {
  PRIVILEGES,
} from 'containers/services/security/user-privileges';
import { DATE_FORMAT } from 'constants/global';
import { STATUS_PENDING } from 'containers/LawyerFeeNote/constants';
import { VictimType } from 'typings/globalTypes';
import { isPendingApprovalClaim } from 'containers/LawyerLegalProceedingsPage/utils';
import withLoading from 'containers/AppContainer/withLoading';
import { LOADERS } from 'containers/AppContainer/Loader/constants';
export interface AppealAddProps {
  intl: IntlShape;
  victims: VictimType[];
  listings: Listings;
  vehicules: Vehicule[];
  judgementAdd: IJudgementAdd;
  uploadDocument: Function;
  setDocumentId: Function;
  documentId: string;
  uploadedDocument: IUploadedDocument;
  resetUploadedDocument: Function;
  requestCreateIncomeCertificate: Function;
  dahirAmount: [];
}

export interface AppealAddProps {
  intl: IntlShape;
  victims: VictimType[];
  listings: Listings;
  vehicules: Vehicule[];
  judgementAdd: IJudgementAdd;
  judgementAddAppeal: IJudgementAdd;
  uploadDocument: Function;
  setDocumentId: Function;
  documentId: string;
  uploadedDocument: IUploadedDocument;
  resetUploadedDocument: Function;
  requestGetJudgementAdd: Function;
  claimId: number;
  claimNumber: string;
  policyInfo: any;
  requestCreateJudgementAdd: Function;
  judiciaryProcessId: number;
  stakeholders: any;
  assignedLawyer: any;
  requestCreateMultipleJudgementAdd: Function;
  requestAddSupportDocument?: Function;
  lossDate: string;
  requestUpdateJudgementAdd: Function;
  isCivilProceeding: boolean;
  requestUpdateJudgementAddDocument: Function;
  currentJudiciaryProcess: any;
  isAssignedLawyer: boolean;
  setDialogOpenFirmReference?: Function;
  loaders: any;
  sagisVictimInfo: any;
  sagisOpposingParties: any;
  feeNotes: any;
  requestCreateIncomeCertificate: Function;
  requestUpdateIncomeCertificate: Function;
  riskKey: string;
  requestMakeDecisionSupportDocument?: Function;
  claimCivilParty: any;
  requestGetClaimCivilParty: Function;
  requestGetDocByDocumentumId: Function;
}

const AppealAdd: React.FC<AppealAddProps> = ({
  uploadDocument,
  documentId,
  uploadedDocument,
  setDocumentId,
  resetUploadedDocument,
  ...props
}): JSX.Element => {
  const [judgementAddDocuments, setJudgementAddDocuments] = useState<
    JudgementADDDocumentType[]
  >([]);
  const [details, setDetails] = useState<Idetails>({
    ...cloneDeep(EMPTY_DETAIL),
    [DETAIL_JUGEMENT_ADD.COURT_FILE]: get(
      props.judgementAdd,
      'judgementAdd.courtFile',
      null,
    ),
  });
  useEffect(() => {
    props.requestGetClaimCivilParty({ claimId: props.claimId });
  }, [props.claimId]);
  const [isDrawerOpen, setIsDrawerOpen] = useState<IOpenState>({
    ...DRAWERS_STATE,
  });
  const [currentIndex, setCurrentIndex] = useState<IndexState>(
    CURRENT_INDEX_STATE,
  );
  const [judgementAdd, setJudgementAdd] = useState<IJudgementAdd | {}>({});
  const [
    areProcedureInformationValidated,
    setAreProcedureInformationValidated,
  ] = useState<boolean>(false);
  const [isCivilPartyPresent] = useState<boolean>(true);

  const [AppealAddDoc, setAppealAddDoc] = useState<AppealAddDocType>({
    ...EMPTY_APPEAL_ADD_DOC,
  });

  const [
    processInformationValidation,
    setProcessInformationValidation,
  ] = useState<any>({});
  const [messageError, setMessageError] = useState<any>({});
  useEffect(() => {
    const procedureInformationValidation = detailsValidator(details);
    setProcessInformationValidation(procedureInformationValidation);
    const translateArrayErrorMessages = arrayTranslate(
      props.intl.formatMessage,
    );
    const { message } = displayErrorText(
      procedureInformationValidation,
      translateArrayErrorMessages(procedureInformationValidation, true),
    );
    setMessageError(message);
    setAreProcedureInformationValidated(
      !!validateFormFields(procedureInformationValidation) &&
        !(
          new Date(addDaysToDate(props.lossDate || '', 1) || '') >
          new Date(get(details, 'hearingDate') || '')
        ) &&
        moment(get(details, 'hearingDate')).format(DATE_FORMAT) !=
          'Invalid date',
    );
  }, [details, props.victims]);

  const setDocument = (document: CorporealDocument) => {
    if (APPEAL_DOC_ID === documentId) {
      setAppealAddDoc(document);
      resetUploadedDocument();
    }
  };
  const shouldDisplayRecap =
    !isEmpty(props.judgementAdd) || !props.isAssignedLawyer;

  const [supportDocumentAdd, setSupportDocumentAdd] = useState({
    ...EMPTY_SUPPORT_DOC,
  });

  const setDocumentAdd = (document: CorporealDocument) => {
    if (SUPPORT_DOC_JUDGEMENT_ADD_ID === documentId) {
      setSupportDocumentAdd(document);
      props.requestAddSupportDocument &&
        props.requestAddSupportDocument({
          ...document,
          isLawyer: true,
          status: STATUS_PENDING,
          judgementAddId: get(props.judgementAdd, ['judgementAdd', 'id']),
          claimId: props.claimId,
          claimNumber: props.claimNumber,
          isInboxesActive: featureService.hasFeature(
            FEATURES.ATTRIBUTION_INBOXES_MANAGER,
          ),
        });
      resetUploadedDocument();
    }
  };
  const readOnly = toBeEdited(get(props, 'judgementAdd.status', ''));
  const handleIsDrawerOpen = (drawer: string) => (index?: number) => (
    event?: React.ChangeEvent<{}>,
  ) => {
    event && event.stopPropagation();

    const previousState = isDrawerOpen[drawer];

    setIsDrawerOpen({
      ...isDrawerOpen,
      [drawer]: !previousState,
    });
    setCurrentIndex({ ...currentIndex, [drawer]: index as number });
  };
  const claimRecap = useSelector((state: any) =>
    get(state.toJS(), ['recap', 'claimRecap']),
  );
  return (
    <Container id="add-bloc">
      {shouldDisplayRecap ? (
        <RecapADD
          listings={props.listings}
          judgementAdd={judgementAdd}
          stakeholders={props.stakeholders}
          assignedLawyer={props.assignedLawyer}
          victims={getVictims(
            props.isCivilProceeding,
            props.currentJudiciaryProcess,
            props.judgementAddAppeal,
            props.victims,
            claimRecap,
          )}
          currentJudiciaryProcess={props.currentJudiciaryProcess}
          vehicules={getVehicles(
            props.isCivilProceeding,
            props.currentJudiciaryProcess,
            props.judgementAddAppeal,
            props.vehicules,
          )}
          uploadDocument={uploadDocument}
          uploadedDocument={uploadedDocument}
          resetUploadedDocument={resetUploadedDocument}
          requestCreateMultipleJudgementAdd={
            props.requestCreateMultipleJudgementAdd
          }
          handleOnEditJudgementAddClick={handleIsDrawerOpen(
            DRAWERS.JUDGEMENT_ADD,
          )}
          handleOnEditProcedureInfoClick={handleIsDrawerOpen(
            DRAWERS.PROCEDURE_INFORMATION,
          )}
          claimNumber={props.claimNumber}
          judiciaryProcessId={props.judiciaryProcessId}
          isManager={userPrivileges.userHasPrivilege(PRIVILEGES.ISCOURTMANAGER)}
          readOnly={!readOnly}
          documentAdd={supportDocumentAdd}
          setDocumentAdd={setDocumentAdd}
          setDocumentId={setDocumentId}
          documentId={documentId}
          setJudgementAdd={setJudgementAdd}
          judgementAddStore={props.judgementAdd}
          requestUpdateJudgementAddDocument={
            props.requestUpdateJudgementAddDocument
          }
          isCreator={
            get(props.judgementAdd, 'lawyerCode') ===
            currentIntervenantStorage.get()?.sagis_code
          }
          isCivilProceeding={props.isCivilProceeding}
          isAssignedLawyer={props.isAssignedLawyer}
          setDialogOpenFirmReference={props.setDialogOpenFirmReference}
          sagisVictimInfo={props.sagisVictimInfo}
          sagisOpposingParties={props.sagisOpposingParties}
          feeNotes={props.feeNotes}
          setOpenFeeNoteDialog={() => {}}
          isConsultation={!props.isAssignedLawyer}
          requestCreateIncomeCertificate={props.requestCreateIncomeCertificate}
          requestUpdateIncomeCertificate={props.requestUpdateIncomeCertificate}
          requestMakeDecisionIncomeCertificate={() => {}}
          riskKey={props.riskKey}
          requestMakeDecisionSupportDocument={
            props.requestMakeDecisionSupportDocument
          }
          policyInfo={props.policyInfo}
          imagineDocuments={[]}
          dahirAmount={props.dahirAmount}
          requestGetDocByDocumentumId={props.requestGetDocByDocumentumId}
          civilDocumentsVictims={props.claimCivilParty}
        />
      ) : (
        <FormsADD
          judiciaryProcessId={props.judiciaryProcessId}
          document={AppealAddDoc}
          setDocument={setDocument}
          setDocumentId={setDocumentId}
          documentId={documentId}
          uploadDocument={uploadDocument}
          judgementAddDocuments={judgementAddDocuments}
          setJudgementAddDocuments={setJudgementAddDocuments}
          listings={props.listings}
          victims={
            isPendingApprovalClaim(claimRecap)
              ? props.victims
              : filterVictim(props.victims)
          }
          vehicules={props.vehicules}
          setDetails={setDetails}
          uploadedDocument={uploadedDocument}
          details={details}
          resetUploadedDocument={resetUploadedDocument}
          canStartJudgementAdd={isCivilPartyPresent}
          canValidateJudgementAddProcedure={areProcedureInformationValidated}
          policyInfo={props.policyInfo}
          claimId={props.claimId}
          claimNumber={props.claimNumber}
          requestCreateJudgementAdd={props.requestCreateJudgementAdd}
          processInformationValidation={processInformationValidation}
          messageError={messageError}
          riskKey={props.riskKey}
          currentJudiciaryProcess={props.currentJudiciaryProcess}
          isCivilProceeding={props.isCivilProceeding}
          setDialogOpenFirmReference={props.setDialogOpenFirmReference}
          loaders={props.loaders}
          isManager={userPrivileges.userHasPrivilege(PRIVILEGES.ISCOURTMANAGER)}
          sagisVictimInfo={props.sagisVictimInfo}
          sagisOpposingParties={props.sagisOpposingParties}
          feeNotes={props.feeNotes}
          requestCreateIncomeCertificate={props.requestCreateIncomeCertificate}
          requestUpdateIncomeCertificate={props.requestUpdateIncomeCertificate}
          requestMakeDecisionIncomeCertificate={() => {}}
          isConsultation={!props.isAssignedLawyer}
          imagineDocuments={[]}
          civilDocumentsVictims={props.claimCivilParty}
          dahirAmount={props.dahirAmount}
        />
      )}
      <EditJudgementAddOnRejection
        listings={props.listings}
        vehicules={props.vehicules}
        judgementAddStore={props.judgementAdd}
        setJudgementAdd={setJudgementAdd}
        judgementAdd={judgementAdd}
        isDrawerOpen={isDrawerOpen}
        handleIsDrawerOpen={handleIsDrawerOpen}
        currentIndex={currentIndex}
        victims={props.victims}
        lossDate={props.lossDate}
        claimNumber={props.claimNumber}
        isCivilProceeding={props.isCivilProceeding}
        requestUpdateJudgementAdd={props.requestUpdateJudgementAdd}
        uploadDocument={uploadDocument}
        uploadedDocument={uploadedDocument}
        resetUploadedDocument={resetUploadedDocument}
        setDocumentId={setDocumentId}
        documentId={documentId}
        isAssignedLawyer={
          get(props.judgementAdd, 'lawyerCode') ===
          currentIntervenantStorage.get()?.sagis_code
        }
        sagisVictimInfo={props.sagisVictimInfo}
        sagisOpposingParties={props.sagisOpposingParties}
        currentJudiciaryProcess={props.currentJudiciaryProcess}
        requestGetDocByDocumentumId={props.requestGetDocByDocumentumId}
        feeNotes={props.feeNotes}
      />
    </Container>
  );
};

export default withLoading(injectIntl(AppealAdd), [LOADERS.JUDGEMENT_ADD]);
